import { graphql, useStaticQuery } from "gatsby";
import { createPayoutText } from "@utils";

export const useOffers = (): {
  offers: StaticOffer[];
  displayOrders: DisplayOrder[];
} => {
  const data = useStaticQuery<StaticOfferQueryResults>(graphql`
    {
      coinmiles {
        offersResponse: getAllOffersWebApp {
          offers {
            id
            advertiserName
            affiliateNetwork
            trackingUrl
            advertiserUrl
            advertiserDescription
            terms
            displayOrder
            activeDate
            payoutType
            categories
            payoutValue
            divisor
            advertiserLogo
            backgroundImageUrl
            serviceArea
          }
          displayOrders {
            countryCode
            displayOrder {
              id
            }
          }
        }
      }
    }
  `);

  const offers: ProcessedOffer[] = data?.coinmiles?.offersResponse?.offers || [];
  const displayOrders: DisplayOrder[] =
    data?.coinmiles?.offersResponse?.displayOrders || [];

  const mappedStaticOffers: StaticOffer[] = offers?.map((offer: ProcessedOffer) => ({
    id: offer.id,
    advertiserName: offer.advertiserName,
    affiliateNetwork: offer.affiliateNetwork,
    trackingUrl: offer.trackingUrl,
    advertiserUrl: offer.advertiserUrl,
    advertiserDescription: offer.advertiserDescription,
    terms: offer.terms,
    categories: offer.categories,
    displayOrder: offer.displayOrder,
    activeDate: offer.activeDate,
    payoutValue: offer.payoutValue,
    serviceArea: offer.serviceArea,
    payoutText: createPayoutText(offer),
    backgroundImage: offer.backgroundImageUrl,
    advertiserLogoImage: offer.advertiserLogo,
  }));

  return { offers: mappedStaticOffers, displayOrders };
};
